export function getEllipsedText(value: string, characters: number): string {
  return `${value.substring(0, characters)}...`;
}
